import { GroupSummaryDto, GroupSummaryModel } from 'api/dto/new/Common/GroupSummary.dto';

export type SummaryItemDto = {
  byGroup: Record<string, GroupSummaryDto>;
  label: string;
};

export type SummaryItemModel = {
  byGroup: Record<string, GroupSummaryModel>;
  label: string;
};

export const mapSummaryItemDtoToModel = (dto: SummaryItemDto): SummaryItemModel => {
  return {
    byGroup: dto.byGroup,
    label: dto.label,
  };
};
